import React from 'react';

import DisplayTypeCompanentMobyG from './DisplayTypeCompanentMoby/DisplayTypeCompanentMobyG';
import DisplayTypeCompanentMobyA from './DisplayTypeCompanentMoby/DisplayTypeCompanentMobyA';
import DisplayTypeCompanentMobyF from './DisplayTypeCompanentMoby/DisplayTypeCompanentMobyF';
import DisplayTypeCompanentPriceMoby from './DisplayTypeCompanentMoby/DisplayTypeCompanentPriceMoby';







function CheckboxListFiltrMoby(props) {


  switch (props.typedisplay) {
    case 'F':
      return (
        <DisplayTypeCompanentMobyF {...props} />
      );
      break;
    case 'A':
      return (
        <>
          < DisplayTypeCompanentMobyA {...props} />
        </>

      );

      break;
    case 'G':

      return (
        <>
          <DisplayTypeCompanentMobyG {...props} />
        </>
      );

      break;
    default:
      return (
        <>
        </>
      );
  }

}


export default CheckboxListFiltrMoby;